var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker-input',{attrs:{"value":_vm.internalValue,"label":_vm.field.label,"block-date":_vm.blocked ? _vm.internalValue : undefined,"filter":""},on:{"input":_vm.setValue}})}
var staticRenderFns = []

export { render, staticRenderFns }